(() => {
  'use strict';
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vv-cookie-preferences]');
    if (!button || button.disabled) return;
    const message = document.getElementById(button.getAttribute('aria-describedby'));
    if (message) message.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      // Shopify loads its native banner separately; allow a click during initial load.
      for (let attempt = 0; attempt < 20 && typeof window.privacyBanner?.showPreferences !== 'function'; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 150));
      }
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (message) message.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
